export function convertToNumber(valueToConvert: string): number {
    const value: number = +valueToConvert;
    return value;
}
export function convertNoCommaAmountToNumber(valueToConvert?: string): number {
    if (valueToConvert === undefined) {
        return 0;
    }
    const value: number = convertToNumber(valueToConvert);
    return value / 100;
}
